import React from "react";
import PropTypes from "prop-types";
import { getTotalArea, getTotalFields } from "utils";
import { GlobeHemisphereWest, Leaf, SelectionAll } from "phosphor-react";
import DashboardPanel from "../DashboardPanel";
import "./index.scss";

const SummaryPanel = ({ totalFarms, farms, redirectTo }) => {
  return (
    <section className="summary-panel">
      <div className="panel-body">
        <div className="header">
          <p className="label">Summary</p>
        </div>
        <div className="panel-content">
          <DashboardPanel
            label="Total Farms"
            mainCount={totalFarms || 0}
            mainTitle="Farms"
            icon={<GlobeHemisphereWest size={24} color="#8A8E99" />}
            redirectTo={redirectTo}
            footerLink="farms"
          />
          <DashboardPanel
            label="Total Fields"
            mainCount={getTotalFields(farms)}
            mainTitle="Fields"
            icon={<Leaf size={24} color="#8A8E99" />}
            footerLink=""
          />
          <DashboardPanel
            label="Total Hectares"
            mainCount={getTotalArea(farms)}
            mainTitle="Ha"
            icon={<SelectionAll size={24} color="#8A8E99" />}
            footerLink=""
          />
        </div>
      </div>
    </section>
  );
};

SummaryPanel.propTypes = {
  totalFarms: PropTypes.string.isRequired,
  farms: PropTypes.shape({
    map: PropTypes.func.isRequired,
    features: PropTypes.string.isRequired,
  }).isRequired,
  redirectTo: PropTypes.func.isRequired,
};

export default SummaryPanel;
